import { useIslandProps, IslandForm } from "@archipelago-js/react"
import React from "react"
import type { ActionEditorProps } from "../components/action-editor/types"
import { ActionEditorForm } from "../components/action-editor/ActionEditorForm"

export default function ActionEditor() {
  const { props } = useIslandProps<ActionEditorProps>()
  const {
    endpointId,
    actionId,
    isEdit,
    cancelUrl,
    billingUrl,
    canForward,
    canComposeActions,
    canExecuteHttpRequest,
    initialAction,
    channels,
    tags,
    ignoreReasons,
    errors: serverErrors,
    conditionHints,
    endpointProvider,
    seenEventTypes,
    variableHints,
    previewUrl,
    previewEvents,
  } = props

  const operation = isEdit ? "update" : "save"

  return (
    <IslandForm
      operation={operation}
      fixedParams={{
        endpoint_id: endpointId,
        ...(actionId ? { action_id: actionId } : {}),
      }}
    >
      {(form) => (
        <ActionEditorForm
          form={form}
          initialAction={initialAction}
          cancelUrl={cancelUrl}
          isEdit={isEdit}
          canForward={canForward}
          canComposeActions={canComposeActions}
          canExecuteHttpRequest={canExecuteHttpRequest}
          billingUrl={billingUrl}
          channels={channels}
          tags={tags}
          ignoreReasons={ignoreReasons}
          serverErrors={serverErrors}
          conditionHints={conditionHints}
          endpointProvider={endpointProvider}
          seenEventTypes={seenEventTypes}
          variableHints={variableHints}
          previewUrl={previewUrl}
          previewEvents={previewEvents}
        />
      )}
    </IslandForm>
  )
}
